import { Navigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { Lock, Loader2 } from 'lucide-react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { GlassCard, Button } from '../components/ui';

export function LoginPage() {
  const auth = useAuth();

  if (auth.isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center space-y-4">
          <Loader2 className="w-8 h-8 text-primary animate-spin mx-auto" />
          <p className="text-gray-600">Checking session...</p>
        </div>
      </div>
    );
  }

  if (auth.isAuthenticated) {
    return <Navigate to="/portal" replace />;
  }

  return (
    <div className="min-h-screen flex flex-col w-full min-w-0">
      <Header />

      <main className="flex-1 w-full min-w-0 container mx-auto px-4 py-8 pb-16 flex items-center justify-center max-w-full">
        <GlassCard className="p-8 md:p-10 max-w-xl w-full text-center" hoverable={false}>
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-5">
            <Lock className="w-8 h-8 text-primary" />
          </div>

          <h1 className="text-3xl font-bold text-gray-900 mb-3">SMA Tickets Portal</h1>
          <p className="text-gray-600 mb-8">
            Sign in with your Star Micronics OneLogin account to continue.
          </p>

          <Button onClick={() => auth.signinRedirect()} size="lg" fullWidth>
            Sign in with OneLogin
          </Button>
        </GlassCard>
      </main>

      <Footer />
    </div>
  );
}
